(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["productInfo-maxdesign"] && !Shopify.designMode) return;
  try {
    
  class ProductInfo extends HTMLElement {
		constructor() {
			super();
			this.settings = JSON.parse(this.querySelector(':scope > [type="application/json"]').innerText);
      this.boundAutoplayVideo = this.autoplayVideo.bind(this);
			this.setVariables();
      this.setVideos();
      this.widthOverride();
      this.updateTranslate();
		}
	 
    setVariables() {
      this.selectors = {
        section: this.parentElement,
        videos: this.querySelectorAll('video'),
        img: this.querySelector('.productInfo__media img'),
        description: this.querySelector('.productInfo__description')
      };
    }
	 
		/*************************
			MAIN METHODS
		*************************/
	 
    setVideos() {
      if (this.selectors.videos.length) {
        Object.defineProperty(HTMLMediaElement.prototype,"playing",{get:function(){return!!(this.currentTime>0&&!this.paused&&!this.ended&&this.readyState>2)}});
        document.body.addEventListener('touchstart', this.boundAutoplayVideo);
        this.onVisibilityChange();
      }
    }

    widthOverride() {
      if (this.settings.widthOverride) {
        if(!document.documentElement.style.getPropertyValue('--sbw')) 
          document.documentElement.style.setProperty('--sbw', `${window.innerWidth - document.body.clientWidth}px`)
      }
    }

    updateTranslate() {
      if (+this.settings.textOffset != 0) {
        if (this.selectors.img) {
          let imgHeight = this.selectors.img.height;
          let imgWidth = this.selectors.img.width;
          let imgRatio = this.settings.imgRatio;
          if (imgHeight*imgRatio > imgWidth) {
            this.selectors.description.style.transform = 'translateX(0%)'
          }
        }
      }
    }
	 
		/*************************
			UTILITY METHODS
		*************************/

    onVisibilityChange() {
      document.addEventListener("visibilitychange", () => {
        document.body.addEventListener('touchstart', this.boundAutoplayVideo);
      });
    }

    autoplayVideo() {
      for (let video of this.selectors.videos) video.playing || video.play().catch(() => {video.controls = true});
      document.body.removeEventListener('touchstart', this.boundAutoplayVideo);
    }
	}

	customElements.define('product-info-maxdesign', ProductInfo);

  } catch(e) { console.error(e); }
})();
})();
